import React , { useState } from 'react';
import ActionsTable from '../ActionsTable/ActionsTable';
import GridContainer from "./GridContainer";
import {ColorPicker} from '../../../libs/components/ColorPicker';
import Select from "react-select";

const getActionLinkByType = (actionType,clientInfo) => {
    switch(actionType){
        case 'phone':
            return clientInfo && clientInfo.phoneNumber ? `tel:${clientInfo.phoneNumber}` : 'tel:XXXXXX';
        case 'whatsapp':
            return clientInfo && clientInfo.phoneNumber ? 
            `https://wa.me/972${clientInfo.phoneNumber.substring(1)}/?text=היי , אני יוצר/ת קשר דרך כרטיס הביקור הדיגיטלי`
            :
            `https://wa.me/972XXXXXX/?text=היי , אני יוצר/ת קשר דרך כרטיס הביקור הדיגיטלי`
        case 'instagram':
            return clientInfo && clientInfo.instagram ? clientInfo.instagram : null;
        case 'facebook': 
            return clientInfo && clientInfo.facebook ? clientInfo.facebook : null;
        default:
            return '';
    }
}

const getActionIconByType = (actionType) => {
    switch(actionType){
        case 'phone':
            return 'phone';
        case 'whatsapp':
            return 'whatsapp';
        case 'instagram':
            return 'instagram1';
        case 'facebook':
            return 'facebook'
        default:
            return null;
    }
}

const getActionDescriptionByType = (actionType) => {
    switch(actionType){
        case 'whatsapp':
            return 'וואטספ';
        case 'instagram':
                return 'אינסטגרם';
        case 'facebook':
            return 'פייסבוק';
        default:
            return null;
    }
}

export default function ActionsPanel({ 
    cardSettings, 
    actions,
    clientInfo,
    editCardSetting,
    removeAction,
    addCardAction, 
    updateAction, 
    setCardActions
}){

    const cardActionsColor = {hex : cardSettings.actionsSettings.color};
    const actionsFontColor = {hex: cardSettings.actionsSettings.fontColor};
    const defaultActionType = {value:'custom',label:'custom'};
    const [selectedActionType,setSelectedActionType] = useState(defaultActionType);
    
    const actionTypeOptions = [
      {value:'custom',label:'custom'},
      {value:'phone',label:'phone'},
      {value:'whatsapp',label:'whatsapp'},
      {value:'instagram',label:'instagram'},
      {value:'facebook',label:'facebook'},
      {value:'modal',label:'modal'}
    ]

    return(
        <div>
            <GridContainer>
                <label>Actions Color:</label>
                <ColorPicker color={cardActionsColor} onChangeCallback={(color)=>{
                // setActionsColor(color)
                editCardSetting("actionsSettings","color",color.hex)
                }}
                />
                <label>font Color:</label>
                <ColorPicker color={actionsFontColor} onChangeCallback={(color)=>{
                // setActionsColor(color)
                editCardSetting("actionsSettings","fontColor",color.hex)
                }}
                />
            </GridContainer>
            <div>
                <ActionsTable actions={actions} 
                onDelete={(id,position) => removeAction(id,position)}
                onRowUpdate={updateAction}
                onChange={(actions) => setCardActions(actions)}
                />
                <div style={{display:'flex'}}>
                <label>type:</label>
                <Select style={{width:150,color:'black'}} options={actionTypeOptions} value={selectedActionType} onChange={(selectedOption) => setSelectedActionType(selectedOption)}/>
                <button onClick={() => {
                    const actionToAdd = {
                        id: null, 
                        description: getActionDescriptionByType(selectedActionType.value), 
                        icon: getActionIconByType(selectedActionType.value),
                        link: getActionLinkByType(selectedActionType.value,clientInfo),
                        type: selectedActionType.value,
                        position: actions.length+1
                    }
                    addCardAction(actionToAdd);
                }}>add action</button>
                </div>
            </div>
        </div>
    )

}